import { ProductTemplateType } from "@sellar-io/api-v2/types";
import { ItemTypeImage } from "../../../../../components";
import { ReactElement } from "react";
import { twMerge } from "tailwind-merge";
import { getDisplayNameByKey, orderableItemValues } from "@sellar-io/common";

export const ProductTemplateItem = ({
  template,
  onClick,
  children,
  className,
}: {
  template: ProductTemplateType;
  onClick?: () => void;
  children?: ReactElement;
  className?: string;
}) => {
  const generateName = (template: ProductTemplateType) =>
    `${template.packQuantity > 1 ? `${template.packQuantity}x ` : ""}${template.volume}${template.displayUnit} ${getDisplayNameByKey(orderableItemValues, template.containerType)}`;

  return (
    <div
      className={twMerge(
        "flex cursor-pointer items-center gap-4 rounded-lg p-4 hover:bg-zinc-50",
        className,
      )}
      onClick={onClick}
    >
      <ItemTypeImage
        product={{
          containerType: template.containerType,
          type: "product",
        }}
      />
      <div className="flex flex-grow flex-col gap-1">
        <span className="font-semibold">{generateName(template)}</span>
      </div>
      {children}
    </div>
  );
};
